import styles from "./download-app-info-box.module.css";
import { UIIcon } from "PosterEditor/common-components/ui-icon-drawing/ui-icon";

interface DownloadAppInfoBoxProps {}

export const DownloadAppInfoBox = (props: DownloadAppInfoBoxProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <UIIcon iconName="INFO" size={23} variant="REGULAR" />
        <h2 className={styles.title}></h2>
      </div>
      <div className={styles.content}>
        <div className={styles.body}>
          <p>
            Upload photos from your photo library and make labels out of them,
            automatically placed right where you took them.
          </p>
          <p>Sign up, and download the helper app to get started.</p>
          <div className={styles.ctas}>
            <a
              href="https://apps.apple.com/us/app/trailart/id6753645992"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.appStoreBadge}
            >
              <img
                className={styles.qrCode}
                src="/ios-app/appstore-qr-badge.png"
                alt="jamiekelly.io"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
